import { useMutationWithRefresh } from '../useMutationWithRefresh';
import companyService, { CompanyForm } from '../../services/companyService';
import { queryKeys } from '../../queryClient';

// สร้างบริษัท
export const useCreateCompany = () => {
  return useMutationWithRefresh({
    mutationFn: (data: CompanyForm) => companyService.createCompany(data),
    invalidateKeys: [
      queryKeys.companies.all,
      queryKeys.sites.all, // sites อาจแสดง dropdown บริษัท
    ],
    successMessage: 'สร้างบริษัทสำเร็จ',
  });
};

// แก้ไขบริษัท
export const useUpdateCompany = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data, ifMatch }: { id: number; data: Partial<CompanyForm>; ifMatch?: string }) =>
      companyService.updateCompany(id, data as any, ifMatch),
    invalidateKeys: [
      queryKeys.companies.all,
      queryKeys.sites.all,
      queryKeys.rentals.all, // rentals แสดงชื่อบริษัท
      queryKeys.contracts.all, // contracts อ้างอิงบริษัท
    ],
    successMessage: 'แก้ไขบริษัทสำเร็จ',
  });
};

// ลบบริษัท
export const useDeleteCompany = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => companyService.deleteCompany(id),
    invalidateKeys: [
      queryKeys.companies.all,
      queryKeys.dashboard.summary, // dashboard อาจแสดงจำนวนบริษัท
    ],
    successMessage: 'ลบบริษัทสำเร็จ',
  });
};

// Sync จาก Flow Account
export const useSyncCompanies = () => {
  return useMutationWithRefresh({
    mutationFn: () => (companyService as any).syncFromFlowAccount(),
    invalidateKeys: [
      queryKeys.companies.all,
      queryKeys.companies.flowAccount,
    ],
    successMessage: 'ซิงค์ข้อมูลบริษัทสำเร็จ',
    errorMessage: 'ไม่สามารถซิงค์ข้อมูลได้ กรุณาตรวจสอบการเชื่อมต่อ',
  });
};